@switch (question.questionSubType) { @case (questionSubType.LIST) {
<div [ngClass]="getAlignmentClass(question)" class="question-content-width">
  @for (option of getDisplayOptions(); track option.order) {
  <div class="form-check gap-2">
    @if(question.questionSpecificOptions?.allowMultipleResponses) {
    <input class="form-check-input mb-1" type="checkbox" [checked]="isSelected(option)"
      (change)="onCheckboxChange(option, $event)" (click)="$event.stopPropagation()" />
    <label class="form-check-label" (click)="onCheckboxChange(option, $event)"
    [style.color]="page === 'theme' ? data?.descriptionColor : ''"
    [style.font-size]="page === 'theme' ? data?.descriptionFontSize : ''"
    [style.font-family]="page === 'theme' ? data?.descriptionFontFamily : ''"
    [style.font-weight]="page === 'theme' ? data?.descriptionFontWeight : ''">{{ option.text | titlecase }}</label>
    } @else {
    <input class="form-check-input mb-1" type="radio" name="previewAnswerRadio" [checked]="isSelected(option)"
      (change)="onRadioChange(option, $event)" (click)="$event.stopPropagation()" />
    <label class="form-check-label" (click)="onRadioChange(option, $event)"
    [style.color]="page === 'theme' ? data?.descriptionColor : ''"
    [style.font-size]="page === 'theme' ? data?.descriptionFontSize : ''"
    [style.font-family]="page === 'theme' ? data?.descriptionFontFamily : ''"
    [style.font-weight]="page === 'theme' ? data?.descriptionFontWeight : ''">{{ option.text | titlecase }}</label>
    }
  </div>
  }
  @if (getOthersOption()) {
  @let othersOption = getOthersOption();
  <div class="form-check">
    @if(question.questionSpecificOptions?.allowMultipleResponses) {
    <input class="form-check-input mb-1" type="checkbox" [checked]="isSelected(othersOption)"
      (change)="onCheckboxChange(othersOption, $event)" (click)="$event.stopPropagation()" />
    <label class="form-check-label" (click)="onCheckboxChange(othersOption, $event)"
    [style.color]="page === 'theme' ? data?.descriptionColor : ''"
    [style.font-size]="page === 'theme' ? data?.descriptionFontSize : ''"
    [style.font-family]="page === 'theme' ? data?.descriptionFontFamily : ''"
    [style.font-weight]="page === 'theme' ? data?.descriptionFontWeight : ''">{{ othersOption.text | titlecase
      }}</label>
    } @else {
    <input class="form-check-input mb-1" type="radio" name="previewAnswerRadio" [checked]="isSelected(othersOption)"
      (change)="onRadioChange(othersOption, $event)" (click)="$event.stopPropagation()" />
    <label class="form-check-label" (click)="onRadioChange(othersOption, $event)"
    [style.color]="page === 'theme' ? data?.descriptionColor : ''"
    [style.font-size]="page === 'theme' ? data?.descriptionFontSize : ''"
    [style.font-family]="page === 'theme' ? data?.descriptionFontFamily : ''"
    [style.font-weight]="page === 'theme' ? data?.descriptionFontWeight : ''">{{ othersOption.text | titlecase
      }}</label>
    }
  </div>
  @if (isOthersSelected(othersOption)) {
  <div class="others-input-container">
    <input type="text" class="others-input" [ngModel]="getOthersText(othersOption)" placeholder="Please specify"
      (ngModelChange)="onOthersTextChange(othersOption, $event)"
      (click)="$event.stopPropagation()"
      />
  </div>
  }
  }
</div>
} @case (questionSubType.BUTTON_CHOICE) {
<!-- Button Choice UI -->
<div [ngClass]="getAlignmentClass(question)" class="question-content-width">
  @for (option of getDisplayOptions(); track option.order) {
  <button class="form-check-button-choice" [class.selected]="isSelected(option)" (click)="onChoiceClick(option, $event)">
    {{ option.text | titlecase }}
  </button>
  }
  @if (getOthersOption()) {
  @let othersOption = getOthersOption();
  <button class="form-check-button-choice" [class.selected]="isSelected(othersOption)"
    (click)="onChoiceClick(othersOption, $event)">
    {{ othersOption.text | titlecase }}
  </button>
  @if (isOthersSelected(othersOption)) {
  <div class="others-input-container">
    <input type="text" class="others-input" [ngModel]="getOthersText(othersOption)" placeholder="Please specify"
      (ngModelChange)="onOthersTextChange(othersOption, $event)"
      (click)="$event.stopPropagation()" />
  </div>
  }
  }
</div>

} @case (questionSubType.DROPDOWN) {
<!-- Dropdown UI -->
<div class="question-content-width">
  @if(question.questionSpecificOptions?.allowMultipleResponses) {
  <app-input-multi-select 
    [options]="getChoiceOptions(question.questionOptions)"
    [control]="multiSelectControl"
    [size]="'small'"
    (change)="onMultiSelectChange($event)"
    (click)="$event.stopPropagation()">
  </app-input-multi-select>
  } @else {
  <app-input-select 
    [options]="getChoiceOptions(question.questionOptions)"
    (change)="onDropdownChange($event)"
    size="small"
    (click)="$event.stopPropagation()">
  </app-input-select>
  }
  @if (getOthersOption() && isOthersSelectedFromDropdown()) {
  @let othersOption = getOthersOption();
  <div class="others-input-container mt-2">
    <input 
      type="text" 
      class="others-input" 
      [ngModel]="getOthersText(othersOption)" 
      placeholder="Please specify"
      (ngModelChange)="onOthersTextChange(othersOption, $event)" />
  </div>
  }
</div>
} @default {
<!-- Unsupported Type -->
<div>Unsupported Type</div>
} }